const CART_KEY = "gs_cart";

export const getCart = () => {
  try { return JSON.parse(localStorage.getItem(CART_KEY) || "[]"); } catch { return []; }
};

export const saveCart = (items) => {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
  window.dispatchEvent(new Event("cart_updated"));
};

export const addToCart = (product, qty = 1) => {
  const cart = getCart();
  const idx = cart.findIndex((i) => i.product_id === product.id);
  if (idx >= 0) cart[idx].quantity += qty;
  else cart.push({
    product_id: product.id,
    name: product.name,
    slug: product.slug,
    price: product.price - (product.discount || 0),
    image: product.images?.[0] || "",
    logo_text: product.logo_text || null,
    logo_text_sub: product.logo_text_sub || null,
    logo_color: product.logo_color || null,
    requires_account_email: !!product.requires_account_email,
    subscription_period: product.subscription_period || null,
    quantity: qty,
    account_email: "",
  });
  saveCart(cart);
};

export const updateAccountEmail = (product_id, account_email) => {
  const cart = getCart().map((i) => (i.product_id === product_id ? { ...i, account_email } : i));
  saveCart(cart);
};

export const updateQty = (product_id, quantity) => {
  let cart = getCart();
  if (quantity <= 0) cart = cart.filter((i) => i.product_id !== product_id);
  else cart = cart.map((i) => (i.product_id === product_id ? { ...i, quantity } : i));
  saveCart(cart);
};

export const removeFromCart = (product_id) => {
  saveCart(getCart().filter((i) => i.product_id !== product_id));
};

export const clearCart = () => saveCart([]);

export const cartCount = () => getCart().reduce((s, i) => s + i.quantity, 0);
export const cartSubtotal = () => getCart().reduce((s, i) => s + i.price * i.quantity, 0);
